import React from 'react';
import { Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const SubscribeCTA = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', padding: '12px 0' }}>
      <Text type="secondary">{t('subscribeCta.text')}</Text>

      <div style={{ marginTop: 16 }}>
        <Button
          type="primary"
          onClick={() => navigate('/credits')}
          style={{
            background: '#1677ff',
            paddingLeft: 24,
            paddingRight: 24,
            height: 40,
            borderRadius: 6,
            fontWeight: 500,
          }}
        >
          {t('subscribeCta.button')}
        </Button>
      </div>
    </div>
  );
};

export default SubscribeCTA;
